<template>
  <div class="outer-wrapper">
    <van-tabs v-model="active" scrollspy sticky>
      <van-tab title="当天">
        <div class="section-wrapper">
          <div class="title-wrapper">
            <p>
              <span style="color:#997562;" class="icon-down">
                <van-icon name="coupon" />
              </span>
              基础数据
            </p>
          </div>
          <day-amount @infoZero="infoZero"></day-amount>
        </div>
        <div class="section-wrapper" v-show="active">
          <div class="title-wrapper">
            <p>
              <span style="color:#997562;" class="icon-down">
                <van-icon name="coupon" />
              </span>
              统计分析
            </p>
          </div>
          <div class="chart-wrapper" >
            <work-group></work-group>
          </div>
        </div>
        <div class="section-wrapper">
            <div class="title-wrapper">
              <p>
                <span style="color:#997562;" class="icon-down">
                  <van-icon name="coupon" />
                </span>
                账款管理(万元)
              </p>
            </div>
            <div class="sub-section">
            <customer-data :info="customerNotPayed"></customer-data>
          </div>
            <van-divider />
          </div>
      </van-tab>
      <van-tab title="本年度">
        <div class="section-wrapper">
          <div class="title-wrapper">
            <p>
              <span style="color:#997562;" class="icon-down">
                <van-icon name="coupon" />
              </span>
              基础数据
            </p>
          </div>
          <year-amount></year-amount>
        </div>
        
        <div class="section-wrapper">
          <div class="title-wrapper">
            <p>
              <span style="color:#997562;" class="icon-down">
                <van-icon name="coupon" />
              </span>
              统计分析
            </p>
          </div>
          <div class="chart-wrapper">
            <year-common sid="e"></year-common>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <year-group sid="e"></year-group>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <year-catagory sid="e"></year-catagory>
          </div>
          <div class="chart-wrapper">
            <year-product sid="e"></year-product>
          </div>
        </div>
      </van-tab>
      <van-tab title="上年度">
        <div class="section-wrapper">
          <div class="title-wrapper">
            <p>
              <span style="color:#997562;" class="icon-down">
                <van-icon name="coupon" />
              </span>
              基础数据
            </p>
          </div>
          <year-amount :year="last_year"></year-amount>
        </div>
        
        <div class="section-wrapper">
          <div class="title-wrapper">
            <p>
              <span style="color:#997562;" class="icon-down">
                <van-icon name="coupon" />
              </span>
              统计分析
            </p>
          </div>
          <div class="chart-wrapper">
            <year-common sid="e2" :year="last_year"></year-common>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <year-group sid="e2" :year="last_year"></year-group>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <year-catagory sid="e2" :year="last_year"></year-catagory>
          </div>
          <div class="chart-wrapper">
            <year-product sid="e2" :year="last_year"></year-product>
          </div>
        </div>
      </van-tab>
      <van-tab title="近7天">
        <div class="section-wrapper">
          <div class="title-wrapper">
            <p>
              <span style="color:#997562;" class="icon-down">
                <van-icon name="coupon" />
              </span>
              统计分析
            </p>
          </div>
          <div class="chart-wrapper">
            <order-common></order-common>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <work-group :timeRange="7" sid="b"></work-group>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <industry-catagory></industry-catagory>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <product-rank></product-rank>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <new-customer :timeRange="7"></new-customer>
          </div>
        </div>
      </van-tab>
      <van-tab title="近30天">
        <div class="section-wrapper">
          <div class="title-wrapper">
            <p>
              <span style="color:#997562;" class="icon-down">
                <van-icon name="coupon" />
              </span>
              基础数据
            </p>
          </div>
          <period-amount :timeRange="30"></period-amount>
        </div>
        <div class="section-wrapper">
          <div class="title-wrapper">
            <p>
              <span style="color:#997562;" class="icon-down">
                <van-icon name="coupon" />
              </span>
              统计分析
            </p>
          </div>
          <div class="chart-wrapper">
            <order-common :timeRange="30" sid="c"></order-common>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <work-group :timeRange="30" sid="c"></work-group>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <industry-catagory :timeRange="30" sid="c"></industry-catagory>
          </div>
          
          <van-divider />
          <div class="chart-wrapper">
            <product-rank :timeRange="30" sid="c"></product-rank>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <new-customer :timeRange="30" sid="c"></new-customer>
          </div>
        </div>
      </van-tab>
      <van-tab title="自定义周期">
        <div class="section-wrapper">
          <div class="title-wrapper">
            <p>
              <span style="color:#997562;" class="icon-down">
                <van-icon name="coupon" />
              </span>
              基础数据
            </p>
          </div>
          <period-amount :timeRange="historyRange"></period-amount>
        </div>
        <div class="section-wrapper">
          <div class="title-wrapper">
            <p>
              <span style="color:#997562;" class="icon-down">
                <van-icon name="coupon" />
              </span>
              统计分析
              <label for class="day-amount">
                近
                <input type="text" v-model.number="historyRange" />天
              </label>
            </p>
          </div>
          <div class="chart-wrapper">
            <order-common :timeRange="historyRange" sid="d" :drawAgain="historyRange"></order-common>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <work-group :timeRange="historyRange" sid="d" :drawAgain="historyRange"></work-group>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <industry-catagory :timeRange="historyRange" sid="d" :drawAgain="historyRange"></industry-catagory>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <product-rank :timeRange="historyRange" sid="d" :drawAgain="historyRange"></product-rank>
          </div>
          <van-divider />
          <div class="chart-wrapper">
            <new-customer :timeRange="historyRange" sid="d" :drawAgain="historyRange"></new-customer>
          </div>
        </div>
      </van-tab>
      
    </van-tabs>
  </div>
</template>
<script>
import workGroup from "./Charts/WorkGroup.vue";
import industryCatagory from "./Charts/IndustryCatagory.vue";
import dayAmount from "./Base/DayAmount.vue";
import orderCommon from "./Charts/OrderCommon.vue";
import productRank from "./Charts/ProductRank.vue";
import periodAmount from "./Base/PeriodAmount.vue";
import customerData from "./Base/CustomerData.vue";
import newCustomer from "./Charts/NewCustomer.vue";
import yearCommon from "./Charts/YearCommon.vue";
import yearAmount from "./Base/YearAmount.vue";
import yearGroup from "./Charts/YearGroup.vue";
import yearCatagory from "./Charts/YearCatagory.vue";
import yearProduct from "./Charts/YearProductRank.vue";

export default {
  name: "indexContent",
  components: {
    workGroup,
    industryCatagory,
    dayAmount,
    orderCommon,
    productRank,
    periodAmount,
    customerData,
    newCustomer,
    yearCommon,
    yearAmount,
    yearGroup,
    yearCatagory,
    yearProduct
  },
  data() {
    return {
      active: 0,
      historyRange: 90,
      customerNotPayed:{
          title:'截至当日应收款前十大客户',
          des:'已完成检测任务但是仍未付款的客户',
          name:'',
          limit:10,
          sale:'',
          askData:"dueCustomer"
        },
    };
  },
  computed: {
    last_year:function(){
      let tmp = new Date();
      return parseInt(tmp.getFullYear())-1;
    }
  },
  watch: {},
  methods: {
    infoZero(value){
      if(value===0){
        this.active = 1;
      }

    }
  },
  created() {}
};
</script>
<style scoped>
.outer-wrapper {
  min-height: 22rem;
  background-color: #fcfcfc;
}

.section-wrapper {
  background-color: #fff;
  padding-top: 0.8rem;
}

.title-wrapper {
  padding: 0.9rem 0.8rem;
  font-size: 0.7rem;
  font-weight: 600;
}

.icon-down {
  position: relative;
  top: 0.06rem;
}

.chart-wrapper {
  overflow: hidden;
}

.day-amount {
  float: right;
}

.sub-section{
  width:100%;
}

.day-amount input {
  width: 2rem;
  border: none;
  outline: none;
  border-bottom: 1px solid #993333;
  text-align: center;
}
</style>